const colors = {
  black: "#000000",
  green: "#30af90",
  red: "#FB3954",
  blue: "#337AB7",
};

export default colors;
